const SUPPORT_MODAL_SAVE_URL = '/support/request/save';

const REDUCER_SUPPORT_MODAL_NAME = 'supportModal';

export {
  SUPPORT_MODAL_SAVE_URL,

  REDUCER_SUPPORT_MODAL_NAME,
};
